import React from 'react';
import { Home as HomeIcon, Users, Clock, User } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
export function MobileLayout({
  children
}: {
  children: React.ReactNode;
}) {
  const location = useLocation();
  const navItems = [{
    path: '/',
    icon: HomeIcon,
    label: 'Inicio'
  }, {
    path: '/barberos',
    icon: Users,
    label: 'Barberos'
  }, {
    path: '/mis-turnos',
    icon: Clock,
    label: 'Mis Turnos'
  }, {
    path: '/perfil',
    icon: User,
    label: 'Perfil'
  }];
  return <div className="min-h-screen bg-dark flex justify-center" data-id="element-202">
      <div className="w-full max-w-md bg-dark relative flex flex-col shadow-2xl overflow-hidden" data-id="element-203">
        {/* Main Content Area */}
        <div className="flex-1 overflow-y-auto pb-20 scrollbar-hide" data-id="element-204">
          {children}
        </div>

        {/* Bottom Navigation */}
        <nav className="absolute bottom-0 left-0 right-0 bg-dark-card border-t border-white/5 px-6 py-4 flex justify-between items-center z-40" data-id="element-205">
          {navItems.map(item => {
          const isActive = location.pathname === item.path || item.path !== '/' && location.pathname.startsWith(item.path);
          return <Link key={item.path} to={item.path} className={`flex flex-col items-center gap-1 transition-colors ${isActive ? 'text-gold' : 'text-light-muted hover:text-light'}`} data-id="element-206">
                <item.icon size={20} strokeWidth={isActive ? 2.5 : 2} data-id="element-207" />
                <span className="text-[10px] font-medium" data-id="element-208">{item.label}</span>
              </Link>;
        })}
        </nav>
      </div>
    </div>;
}